export default "__VITE_ASSET__fe8c8641__"